import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      transform="translate(4 6)"
      d="M6.99967 3.66634V0.333008L13.6663 6.99967L6.99967 13.6663V10.333H0.333008V3.66634H6.99967Z"
      fill={fill}
    />
  </g>
);

export default Icon;
